import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Spinner,
} from "reactstrap"
import Select from "react-select"

//actions
import MetaTag from "components/Common/Meta-tag"
import {
  getSalesReportData,
  getPurchaseReportData,

  getDashboardLeadChartData,
  getDashboardSaleChartData,
  getDashboardVehicleChartData,
  getLeadToSaleRatio,
} from "store/actions"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import TotalLeadsChart from "./Charts/totalLeadsChart"
import CarSoldChart from "./Charts/carSoldChart"
import LeadToSale from "./Charts/leadToSale"
import moment from "moment"
import { DateRange } from "react-date-range"
import BranchFilter from "components/Common/BranchFilter"
import { useRole, ROLE_TYPES } from "hooks/useRole"
import DashboardReportSection from "./DashboardReportSection"

const Dashboard = () => {
  const dispatch = useDispatch()
  const { isAnyRole, isRole, isSuperAdmin } = useRole()
  const branch = sessionStorage.getItem("branchId")
  const branchName = sessionStorage.getItem("branch")
  const history = useHistory()
  const {
    dashboardData,
    loading,
    salesReportLoading,
    salesReport,
    purchaseReportLoading,
    purchaseReport,
    selectedBranch,
    vehicleChart,
    leadChart,
  } = useSelector(state => ({
    dashboardData: state.Dashboard.dashboardData,
    salesReport: state.Dashboard.salesReportData,
    salesReportLoading: state.Dashboard.salesReportLoading,
    purchaseReport: state.Dashboard.purchaseReportData,
    purchaseReportLoading: state.Dashboard.purchaseReportLoading,
    loading: state.Dashboard.loading,
    selectedBranch: state.Branches.selectedBranch,

    leadChart: state?.Dashboard?.leadChartData,
    vehicleChart: state?.Dashboard?.vehicleChartData,
    saleChart: state?.Dashboard?.saleChartData,
    allMatchLit: state?.MatchList?.matchingLists,
  }))

  const activeBranch =
    selectedBranch?.label === "All" || branchName === "All"
      ? ""
      : selectedBranch?.value || branch || ""



  useEffect(() => {
    if (
      isAnyRole([
        ROLE_TYPES.ENQUIRY_MANAGER,
        ROLE_TYPES.ENQUIRY_ANALYST,
        ROLE_TYPES.SALES_MANAGER,
        ROLE_TYPES.SALES_EXECUTIVE,
      ])
    ) {
      history?.push("/lead/all")
    }
  }, [isAnyRole])

  useEffect(() => {
    if (
      isAnyRole([
        ROLE_TYPES.SUPER_ADMIN,
        ROLE_TYPES.ADMIN,
        ROLE_TYPES.GENERAL_MANAGER,
        ROLE_TYPES.MANAGING_DIRECTOR,
      ])
    ) {
      dispatch(
        getDashboardLeadChartData({
          branch: activeBranch,
        })
      )
      dispatch(
        getDashboardVehicleChartData({
          branch: activeBranch,
        })
      )
      // sale ratio
      dispatch(
        getDashboardSaleChartData({
          branch: activeBranch,
        })
      )
      // lead to sale ratio
      dispatch(
        getLeadToSaleRatio({
          branch: activeBranch,
        })
      )
    }
  }, [dispatch, activeBranch])

  const [dateFormat, setDateFormat] = useState({
    label: "This month",
    value: "thisMonth",
  })

  const today = moment().endOf("day").toDate()

  const [customDate, setCustomDate] = useState({
    startDate: moment().startOf("month").toDate(),
    endDate: moment().endOf("month").isAfter(today)
      ? today
      : moment().endOf("month").toDate(),
  })

  useEffect(() => {
    console.log("payload", customDate)

    if (dateFormat.value === "customMonth") {
      dispatch(
        getSalesReportData({
          filter: dateFormat.value,
          customDate,
          selectedBranch: activeBranch,
        })
      )
      dispatch(
        getPurchaseReportData({
          filter: dateFormat.value,
          customDate,
          selectedBranch: activeBranch,
        })
      )
    } else {
      dispatch(
        getSalesReportData({
          filter: dateFormat.value,
          selectedBranch: activeBranch,
        })
      )
      dispatch(
        getPurchaseReportData({
          filter: dateFormat.value,
          selectedBranch: activeBranch,
        })
      )
    }
  }, [dispatch, dateFormat, customDate, activeBranch])

  useEffect(() => {
    if (isRole(ROLE_TYPES.PURCHASE_MANAGER)) {
      history?.push("/vehicle/all")
    }
  }, [isRole])

  const dateFormatOptions = [
    {
      label: "Today",
      value: "today",
    },
    {
      label: "Yesterday",
      value: "yesterday",
    },
    {
      label: "This week",
      value: "thisWeek",
    },
    {
      label: "This month",
      value: "thisMonth",
    },
    {
      label: "Previous month",
      value: "previousMonth",
    },
    {
      label: "Custom",
      value: "customMonth",
    },
  ]

  // Popover state
  const [showDateRange, setShowDateRange] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const handleDateRangeClick = event => {
    setAnchorEl(event.currentTarget)
    setShowDateRange(!showDateRange)
  }

  // Outside click handler for date range popover
  useEffect(() => {
    if (!showDateRange) return

    const handleClickOutside = event => {
      // If the popover or button contains the click, do nothing
      if (
        anchorEl &&
        (anchorEl.contains(event.target) ||
          document
            .getElementById("custom-date-range-popover")
            ?.contains(event.target))
      ) {
        return
      }
      setShowDateRange(false)
      setAnchorEl(null)
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [showDateRange, anchorEl])



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTag title="Dashboard" />
        <Container fluid>
          <>
            <Row>
              <Col sx={8}>
                <div
                  style={{ minWidth: "200px", maxWidth: "100%" }}
                  className="mb-3 d-flex algin-items-center justify-content-start gap-3 w-100"
                >
                  <Select
                    value={dateFormat}
                    placeholder={dateFormat?.label}
                    onChange={e => {
                      setDateFormat(e)
                    }}
                    options={dateFormatOptions}
                    classNamePrefix="select2-selection minimum-w-200"
                    isLoading={false}
                  />

                  {dateFormat.value === "customMonth" && (
                    <>
                      <Button
                        color="info"
                        outline
                        size="sm"
                        className="mt-0 px-3"
                        onClick={handleDateRangeClick}
                        style={{ width: "150px" }}
                      >
                        {moment(customDate.startDate).format("DD MMM")} -{" "}
                        {moment(customDate.endDate).format("DD MMM")}
                      </Button>

                      {showDateRange && (
                        <div
                          id="custom-date-range-popover"
                          style={{
                            position: "absolute",
                            zIndex: 1,
                            background: "#fff",
                            borderRadius: 13,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            marginTop: 50,
                            right: 75,
                          }}
                        >
                          <DateRange
                            ranges={[
                              {
                                startDate: customDate.startDate || new Date(),
                                endDate: customDate.endDate || new Date(),
                                key: "selection",
                              },
                            ]}
                            onChange={ranges => {
                              setCustomDate({
                                startDate: ranges.selection.startDate,
                                endDate: ranges.selection.endDate,
                              })
                            }}
                            maxDate={new Date()}
                          />
                        </div>
                      )}
                    </>
                  )}
                  {isSuperAdmin() && <BranchFilter />}
                </div>

                {/* // start of sales report  */}
                <div className="mb-4">
                  <h6 className="mb-3">Sales Report</h6>
                  <DashboardReportSection
                    reportData={salesReport}
                    loading={salesReportLoading}
                    card1Label="Total Leads"
                    card2Label="Cars Sold"
                  />
                </div>
                {/* // end of sales report */}

                {/* // start of purchase report  */}
                <div className="mb-4">
                  <h6 className="mb-3">Purchase Report</h6>
                  <DashboardReportSection
                    reportData={purchaseReport}
                    loading={purchaseReportLoading}
                    card1Label="Total Leads"
                    card2Label="Cars Purchased"
                  />
                </div>
                {/* // end of purchase report */}
              </Col>

              <Col sx={4}>
                <Button outline className="mb-3 w-25 text-black border-black">
                  Last 12 Month
                </Button>
                <Card style={{ borderRadius: 5, height: 400 }}>
                  <CardBody>
                    Car Sold
                    {loading ? (
                      <Spinner color="success" className="d-block m-auto" />
                    ) : (
                      <CarSoldChart vehicleChart={vehicleChart} />
                    )}
                  </CardBody>
                </Card>
                <Card style={{ borderRadius: 5, height: 400 }}>
                  <CardBody>
                    Total Leads
                    {loading ? (
                      <Spinner color="success" className="d-block m-auto" />
                    ) : (
                      <TotalLeadsChart leadChartData={leadChart} />
                    )}
                  </CardBody>
                </Card>
                <Card style={{ borderRadius: 5 }}>
                  <LeadToSale chartData={dashboardData?.leadToSaleRatio || 0} />
                </Card>
              </Col>
            </Row>
          </>
          {/* )} */}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
